<div class="output-report">
  <!-- 帳票変更プルダウン-->
  <div class="dropDownArea">
    <p-dropdown
      name="reportChangeDropdown"
      styleClass="reportChangeDropdown"
      [options]="searchDataList"
      (onChange)="reportChange()"
      [(ngModel)]="rkind"
      optionValue="rkind"
      optionLabel="reportname"
      appendTo="body"
    >
    </p-dropdown>
  </div>

  <!-- 検索フォーム -->
  <form [formGroup]="searchForm">
    <!-- 検索情報出力領域 -->
    <p-table
      [value]="searchItemList"
      styleClass="p-datatable-sm ReportSearchForm"
    >
      <ng-template pTemplate="body" let-searchItem>
        <tr>
          <!-- カラム名称 -->
          <td class="label">
            <label>
              {{ searchItem.column_name }}
            </label>
          </td>

          <!-- 検索項目タイプを判定 -->
          <td class="input-form">
            <!-- テキスト -->
            <div class="ui-fluid" *ngIf="searchItem.search_type == 'text'">
              <input
                [name]="searchItem.column_id"
                class="text"
                type="text"
                size="30"
                [formControlName]="searchItem.column_id"
                pInputText
              />
            </div>

            <!-- 日付 -->
            <div class="ui-fluid" *ngIf="searchItem.search_type == 'date'">
              <ng class="input-start-end-width">
                <div class="p-col-fixed">
                  <p-calendar
                    [name]="searchItem.column_id + '_FROM'"
                    [showIcon]="true"
                    [showButtonBar]="true"
                    [yearNavigator]="true"
                    dateFormat="yy/mm"
                    dataType="string"
                    appendTo="body"
                    view="month"
                    yearRange="2000:2999"
                    [formControlName]="searchItem.column_id + '_FROM'"
                    translate
                  ></p-calendar>
                  &nbsp;〜&nbsp;
                  <p-calendar
                    [name]="searchItem.column_id + '_TO'"
                    [showIcon]="true"
                    [showButtonBar]="true"
                    [yearNavigator]="true"
                    dateFormat="yy/mm"
                    dataType="string"
                    appendTo="body"
                    view="month"
                    yearRange="2000:2999"
                    [formControlName]="searchItem.column_id + '_TO'"
                    translate
                  ></p-calendar>
                </div>
              </ng>
            </div>

            <!-- 数値 -->
            <div *ngIf="searchItem.search_type == 'number'">
              <ng class="input-start-end-width">
                <div class="p-col-fixed">
                  <input
                    [name]="searchItem.column_id + '_FROM'"
                    type="number"
                    class="number"
                    [formControlName]="searchItem.column_id + '_FROM'"
                    pInputText
                  />
                  &nbsp;〜&nbsp;
                  <input
                    [name]="searchItem.column_id + '_TO'"
                    type="number"
                    class="number"
                    [formControlName]="searchItem.column_id + '_TO'"
                    pInputText
                  />
                </div>
              </ng>
            </div>

            <!-- チェックボックス -->
            <div class="ui-fluid" *ngIf="searchItem.search_type == 'checkbox'">
              <ng-container
                *ngFor="let code_list of searchItem.code_list_multi"
              >
                <p class="p-field-checkbox">
                  <p-checkbox
                    [name]="searchItem.column_id"
                    [label]="code_list.name"
                    [value]="code_list.value"
                    [formControl]="searchForm.controls[searchItem.column_id]"
                  ></p-checkbox>
                </p>
              </ng-container>
            </div>

            <!-- プルダウン -->
            <div class="ui-fluid" *ngIf="searchItem.search_type == 'pulldown'">
              <p-multiSelect
                [name]="searchItem.column_id"
                [options]="searchItem.code_list_multi"
                emptyFilterMessage="検索結果が存在しません"
                optionLabel="name"
                optionValue="value"
                appendTo="body"
                [formControlName]="searchItem.column_id"
              ></p-multiSelect>
            </div>

            <!-- テキストエリア -->
            <div class="ui-fluid" *ngIf="searchItem.search_type == 'list'">
              <textarea
                [name]="searchItem.column_id"
                maxlength="10000"
                [formControlName]="searchItem.column_id"
                pInputTextarea
              ></textarea>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </form>

  <!-- ボタンエリア -->
  <div class="buttonArea">
    <input
      pButton
      type="submit"
      value="帳票出力"
      class="p-button-raised p-mr-2 button"
      (click)="outputReport()"
    />
    <input
      pButton
      type="submit"
      value="クリア"
      class="p-button-raised p-mr-2 button"
      (click)="reset()"
    />
  </div>
</div>
